import { atom } from "recoil";

export const isRegionState = atom({
    key: "region",
    default: "전국",
});
